"use client";

import { Accordion } from "@components/ngg";
import xss from "xss";

import Icon from "./icon";

export default function Description({
  title,
  description,
  className,
}: {
  title: string;
  description: string;
  className?: string;
}) {
  return (
    <Accordion
      IconComponent={Icon}
      WrapperComponent="div"
      transitionProps={{ appear: false }}
      classNames={{
        wrapper: className,
        button: "text-left items-center leading-4 p-4 uppercase rounded-none",
        panel: "p-4",
      }}
      title={title}
      defaultOpen
    >
      <div
        className="text-base"
        dangerouslySetInnerHTML={{
          __html: xss(description),
        }}
      />
    </Accordion>
  );
}
